export const money = (n, dp = 0) => {
  if (n === null || n === undefined) return "—";
  return "$" + Number(n).toLocaleString("en-US", { minimumFractionDigits: dp, maximumFractionDigits: dp });
};

export const moneyCompact = (n) => {
  if (n === null || n === undefined) return "—";
  const a = Math.abs(n);
  if (a >= 1e9) return "$" + (n / 1e9).toFixed(2) + "B";
  if (a >= 1e6) return "$" + (n / 1e6).toFixed(1) + "M";
  if (a >= 1e3) return "$" + (n / 1e3).toFixed(0) + "K";
  return "$" + Number(n).toFixed(0);
};

export const num = (n) => (n === null || n === undefined ? "—" : Number(n).toLocaleString("en-US"));

export const perWatt = (n) => (n === null || n === undefined ? "—" : "$" + Number(n).toFixed(4) + "/W");

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "—";
  }
};

export const daysLabel = (d) => {
  if (d === null || d === undefined) return "";
  if (d < 0) return `${Math.abs(d)}d overdue`;
  if (d === 0) return "due today";
  return `in ${d}d`;
};

export const STATUS_LABELS = {
  lead: "Intake",
  new: "Intake",
  review: "Reviewing",
  qualified: "Pursuing",
  no_bid: "Closed",
  estimating: "Estimating",
  proposal: "Proposal",
  sent: "Submitted",
  won: "Won",
  lost: "Lost",
  declined: "Closed",
  cancelled: "Cancelled",
};

export const STATUS_TONE = {
  lead: "bg-slate-100 text-slate-700",
  new: "bg-slate-100 text-slate-700",
  review: "bg-[#003E87]/10 text-[#003E87]",
  qualified: "bg-[#F4C400]/15 text-[#8a6d00]",
  no_bid: "bg-slate-100 text-slate-500",
  estimating: "bg-amber-50 text-amber-700",
  proposal: "bg-indigo-50 text-indigo-700",
  sent: "bg-slate-900 text-white",
  won: "bg-emerald-50 text-emerald-700",
  lost: "bg-rose-50 text-rose-700",
  declined: "bg-slate-100 text-slate-500",
  cancelled: "bg-slate-100 text-slate-500",
};

export const ROLE_LABELS = {
  owner: "Owner",
  admin: "Admin",
  chief_estimator: "Chief Estimator",
  estimator: "Estimator",
  business_development: "Business Development",
  project_manager: "Project Manager / Field",
};

const DISCIPLINES = new Set(["mechanical", "electrical", "civil", "structural", "pile", "piles", "racking", "modules", "epc", "install"]);
// "Aquila Energy - City of Green Bay - Mechanical" -> "City of Green Bay"
export function shortSite(name) {
  let parts = String(name || "").split(" - ").map((p) => p.trim()).filter(Boolean);
  if (!parts.length) return String(name || "");
  if (parts.length >= 2 && DISCIPLINES.has(parts[parts.length - 1].toLowerCase())) parts = parts.slice(0, -1);
  if (parts.length >= 2) parts = parts.slice(1);
  return parts.join(" - ") || String(name);
}
